import { render, staticRenderFns } from "./IconBookmarkAltOutline.vue?vue&type=template&id=1f05465b"
import script from "./IconBookmarkAltOutline.vue?vue&type=script&lang=js"
export * from "./IconBookmarkAltOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports